module.exports = __webpack_public_path__ + "img/vehicle-no-image.767bf601.png";